module.exports = __webpack_public_path__ + "img/auth.83402d36.jpg";